import gql from "graphql-tag";

export default gql`
  query IssuerPeers(
    $listingCountry: IssuerListingCountry!
    $contextIssuer: String!
    $narrowCriteria: [IssuerSearchNarrowCriteria!]!
    $top: Int = 5
  ) {
    issuerPeers(
      listingCountry: $listingCountry
      contextIssuer: $contextIssuer
      narrowCriteria: $narrowCriteria
      top: $top
    ) {
      _id
      name
      listingExchangeCode
      tickerSymbol
      tickerSymbols
      ... on AmericanIssuerSearchResultNode {
        sector
        industry
        industryGroup
        isReit
        isDepositoryReceipt
        numberOfEmployees
      }
      marketCapitalization {
        totalCapitalization
      }
      niceLogo {
        url
        geometry
        dominantColor
        colorPalette
      }
    }
  }
`;
